import React from 'react';
import { Link } from '@material-ui/core';
import { IRowData } from './ReportList';
import settings from '../../services/settings';

const TemporaryCrewExternalUrl = settings.getCrewURI();

interface IProps {
  rowData: IRowData;
}

const TargetCell = (props: IProps): JSX.Element => {
  const { rowData } = props;
  switch (rowData.targetObject) {
    case 'story':
      return (
        <Link href={`${TemporaryCrewExternalUrl}/stories/${rowData.storyId}`} target="_blank" component="a" variant="body2">
          {`story - ${rowData.storyId}`}
        </Link>
      );

    case 'chapter':
    case 'episode':
      return (
        <Link component="a" target="_blank" variant="body2" href={`${TemporaryCrewExternalUrl}/episodes/${rowData.episodeId}`}>
          {`episode - ${rowData.episodeId}`}
        </Link>
      );

    default:
      return <span>rowData.id</span>;
  }
};

export default TargetCell;
